import { useFormik } from 'formik';
import { initialValues } from './formData'; // Importa los valores iniciales
import { validationSchema } from './formData';
import { MultiDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface ObjectiveAndResponseStrategyForm {
    [key: string]: MultiDynamicField[];
}

export const useObjectiveAndResponseStrategy = (
    chatAssistant: ChatAssistant
) => {
    const formikObjectiveAndResponseStrategy =
        useFormik<ObjectiveAndResponseStrategyForm>({
            initialValues,
            validationSchema,
            onSubmit: console.log,
        });

    useEffect(() => {
        if (chatAssistant) {
            formikObjectiveAndResponseStrategy.setValues({
                objectiveAndResponseStrategy:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.objectiveAndResponseStrategy ??
                    initialValues.objectiveAndResponseStrategy,
            });
        }
    }, [chatAssistant]);

    return { formikObjectiveAndResponseStrategy };
};
